export const AGE_POLICY_VERSION = '2026-11-03';

export const todayInSkopje = () => new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Skopje', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(new Date());

export const isAdult = (value, today = todayInSkopje()) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return false;
  const [year, month, day] = value.split('-').map(Number);
  if (year < 1 || month < 1 || month > 12 || day < 1) return false;
  const daysInMonth = new Date(Date.UTC(year < 100 ? 2000 + year : year, month, 0)).getUTCDate();
  // Years below 100 need explicit leap-year calculation.
  const days = month === 2 ? ((year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)) ? 29 : 28) : daysInMonth;
  if (day > days) return false;
  const anniversaryYear = year + 18;
  const anniversaryDay = month === 2 && day === 29
    && !(anniversaryYear % 4 === 0 && (anniversaryYear % 100 !== 0 || anniversaryYear % 400 === 0)) ? 28 : day;
  const anniversary = `${String(anniversaryYear).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(anniversaryDay).padStart(2, '0')}`;
  return anniversary <= today;
};

// The max attribute is a convenience. isAdult remains authoritative in the form.
export const latestAdultBirthDate = () => {
  const [year, month, day] = todayInSkopje().split('-').map(Number);
  const birthYear = year - 18;
  const leapBirthYear = birthYear % 4 === 0 && (birthYear % 100 !== 0 || birthYear % 400 === 0);
  const leapTodayYear = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  if (month === 2 && day === 28 && !leapTodayYear && leapBirthYear) return `${birthYear}-02-29`;
  const lastDay = new Date(Date.UTC(birthYear, month, 0)).getUTCDate();
  return `${year - 18}-${String(month).padStart(2, '0')}-${String(Math.min(day, lastDay)).padStart(2, '0')}`;
};
